import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AccountSetupFormState, AccountSetupOutletContext } from '../../components/signup/types';

const PasswordSetupPage = () => {
  const [formState, setFormState] = useState<AccountSetupFormState>({});

  const updateFormState = (updates: Partial<AccountSetupFormState>) => {
    setFormState((prev) => ({ ...prev, ...updates }));
  };

  const outletContext: AccountSetupOutletContext = {
    formState,
    updateFormState,
  };

  return <Outlet context={outletContext} />;
};

export default PasswordSetupPage;
